// src/composables/useUser.js
//
// Etap 9 Faza 0: authentication still comes from Firebase, but ROLES now come
// from Postgres via GET /api/auth/me (see src/auth/roleClaims.js). The exported
// shape is unchanged — `{ user, claims }` where claims is
// `{ admin, konstruktor, sprzedawca, produkcja }` — so downstream consumers
// (AppProfile, AppMenu, AppSubmenu, AppTopBar) need no change.
import { ref, readonly } from 'vue';
import { onAuthStateChanged } from 'firebase/auth';
import { projectAuth } from '@/firebase/config';
import { getRoleClaims, clearRoleClaims } from '@/auth/roleClaims';

const user = ref(null);
const claims = ref(null);

// Set up reactive tracking once
onAuthStateChanged(projectAuth, async (newUser) => {
  user.value = newUser;
  if (newUser) {
    try {
      claims.value = await getRoleClaims(newUser);
    } catch (err) {
      console.error('Failed to fetch user roles:', err);
      claims.value = null;
    }
  } else {
    clearRoleClaims();
    claims.value = null;
  }
});

export default function useUser() {
  return {
    user: readonly(user),     // readonly to prevent accidental mutation
    claims: readonly(claims)  // readonly claims too
  };
}
